module.exports = __webpack_public_path__ + "static/img/administrative.79649bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/administrative.png
// module id = xIG7
// module chunks = 0